export function isValidUpi(upi: string) {
  if (!upi || typeof upi !== "string") return false;

  const upiRegex = /^(?:[a-zA-Z0-9._-]{2,256}|[6-9]\d{9})@[a-zA-Z0-9]{2,64}$/;
  return upiRegex.test(upi.trim());
}
